import { showErrorToast } from "./toast";

export const showFirstFormErrorToast = (
    formErrors,
    fallbackMessage = "Please fill in all required fields."
) => {
    const firstMessage = Object.values(formErrors || {})
        .map((fieldError) => fieldError?.message)
        .find((message) => typeof message === "string" && message.trim().length > 0);

    showErrorToast(firstMessage || fallbackMessage);
};

